export default __webpack_public_path__ + "static/media/logo.063ef95b.png";